const features = [
  {
    eyebrow: 'Кандидати',
    title: 'Збираєте кандидатів в одну систему',
    highlightPart: 'одну систему',
    desc: 'Відгуки з OLX, job-порталів, сайту, форм, рекомендацій і телефонії — в одній базі. Рекрутер бачить кандидата, телефон, роль, локацію та статус.',
    image: 'https://storage.readdy-site.link/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/c160d97c-6ef5-4e62-be11-1faba407a091_compressed_unnamed.webp',
    bullets: ['єдина база з усіх каналів', 'історія контактів і наступний крок', 'працює навіть без резюме'],
  },
  {
    eyebrow: 'Контроль',
    title: 'Контролюєте швидкість обробки',
    highlightPart: 'Контролюєте',
    desc: 'HURMA показує статус кожного кандидата на кожному етапі. Хто має передзвонити, де потрібне рішення керівника, хто завис перед виходом.',
    image: 'https://storage.readdy-site.link/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/28c1ef4a-8084-465d-8bb7-ce0abd9268b1_compressed_hurma_recruiting-work_with_candidates.webp',
    bullets: ['SLA-контроль на кожному етапі', 'виявлення вузьких місць у воронці', 'автоматичні нагадування рекрутерам'],
  },
  {
    eyebrow: 'Пребординг',
    title: 'Заощаджуєте 60% часу на пребордингу',
    highlightPart: 'Заощаджуєте 60%',
    desc: 'Вихід на роботу — це не фінал найму. Збираєте документи, ставите задачі HR і керівнику, контролюєте строки до стабільної роботи.',
    image: 'https://storage.readdy-site.link/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/b528fb00-376c-410e-8c5d-b52774a9fb1d_compressed_Group.webp',
    bullets: ['чеклісти та задачі для всіх учасників', 'контроль строків збору документів', 'передача інформації між відділами'],
  },
  {
    eyebrow: 'Аналітика',
    title: 'Бачите аналітику по мережі',
    highlightPart: 'Бачите аналітику',
    desc: 'Загальна картина по всіх виробничих майданчиках: скільки вакансій відкрито, де найм сповільнюється, які джерела дають кандидатів.',
    image: 'https://storage.readdy-site.link/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/ff50845c-2ac5-43d7-863e-64495cb2d36e_compressed_hurma_hrm-advanced_analytics.webp',
    bullets: ['вакансії, швидкість, джерела — в одному вікні', 'порівняння локацій і рекрутерів', 'плинність і час найму по майданчиках'],
  },
  {
    eyebrow: 'Інтеграція',
    title: 'Передаєте дані в ERP',
    highlightPart: 'дані в ERP',
    desc: 'HURMA закриває HR-шлях: кандидати, працівники, пребординг, адаптація. Дані передаються в ERP, LMS або BI без ручного дублювання.',
    image: 'https://storage.readdy-site.link/project_files/4209c496-91bf-433d-89c1-fd9f1706b442/ecd146fe-daa2-4378-bb86-945b468fc4ae_compressed_unnamed.webp',
    bullets: ['інтеграція з 1С, SAP, Oracle', 'автоматична синхронізація даних', 'жодного ручного перенесення'],
  },
];

export default function SolutionSection() {
  return (
    <section id="solution" className="py-24 lg:py-32 bg-white">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10">

        <div className="text-center mb-20 lg:mb-28 max-w-[700px] mx-auto">
          <h2
            className="font-heading font-bold text-[#1d1d1f] leading-[1.08] tracking-tight mb-5"
            style={{ fontSize: 'clamp(2rem, 4.5vw, 3.5rem)' }}
          >
            Від вакансії до ERP —<br />в єдиному контурі
          </h2>
          <p className="text-gray-500 text-lg lg:text-xl leading-relaxed">
            З HURMA ви встигаєте все: збираєте кандидатів, контролюєте швидкість, звітуєте та інтегруєте дані.
          </p>
        </div>

        <div className="flex flex-col gap-24 lg:gap-32">
          {features.map((f, i) => {
            const isReversed = i % 2 !== 0;

            const textContent = (
              <>
                <h3 className="font-heading font-semibold text-[#1d1d1f] text-[28px] lg:text-[34px] leading-[1.12] mb-4">
                  {f.highlightPart
                    ? (() => {
                        const idx = f.title.indexOf(f.highlightPart);
                        const before = f.title.slice(0, idx);
                        const after = f.title.slice(idx + f.highlightPart.length);
                        return <>{before}<span style={{ color: '#F96B25' }}>{f.highlightPart}</span>{after}</>;
                      })()
                    : f.title}
                </h3>
                <p className="text-gray-500 text-lg lg:text-xl leading-relaxed mb-5">
                  {f.desc}
                </p>
                <div className="flex flex-col gap-2">
                  {f.bullets.map((b, bi) => (
                    <div key={bi} className="flex items-center gap-2.5">
                      <span
                        className="w-1.5 h-1.5 rounded-full flex-shrink-0"
                        style={{ backgroundColor: '#F96B25' }}
                      />
                      <span className="text-gray-400 text-base lg:text-lg">{b}</span>
                    </div>
                  ))}
                </div>
              </>
            );

            const imageContent = (
              <div className="rounded-2xl overflow-hidden">
                <img
                  src={f.image}
                  alt={f.title}
                  className="w-full h-auto object-cover object-top block"
                />
              </div>
            );

            return (
              <div key={f.title} className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
                <div className={`flex-1 ${isReversed ? 'order-1' : 'order-1 lg:order-2'}`}>
                  {imageContent}
                </div>
                <div className={`flex flex-col justify-center max-w-[420px] ${isReversed ? 'order-2' : 'order-2 lg:order-1'}`}>
                  {textContent}
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}